import { VeryCompactCategoryResponse } from '@business/entities/category';
import { Endpoint } from '../endpoint';
import {
  CalendarImportRequest,
  CalendarTemplateId,
  CalendarTemplateImportId,
  CalendarTemplateImportResponse,
  CalendarTemplatePreviewEventResponse,
  CalendarTemplateResponse,
  ManualEventsSummaryResponse,
  ShiftTemplateImportRequest,
  ShiftTemplateImportResponse,
} from '@business/entities/calendar_template';

export function fetchCalendarTemplates() {
  return Endpoint.get<CalendarTemplateResponse[]>(`@gc/calendar-templates`);
}

export function createCalendarTemplate(title: string) {
  return Endpoint.post<CalendarTemplateResponse>(`@gc/calendar-templates`, { data: { title } });
}

export function updateCalendarTemplate(id: CalendarTemplateId, title: string) {
  return Endpoint.patch<CalendarTemplateResponse>(`@gc/calendar-templates/${id}`, { data: { title } });
}

export function duplicateCalendarTemplate(id: CalendarTemplateId, title: string) {
  return Endpoint.post<CalendarTemplateResponse>(`@gc/calendar-templates/duplicate/${id}`, { data: { title } });
}

export function deleteCalendarTemplate(calendarTemplateId: CalendarTemplateId) {
  return Endpoint.delete<void>(`@gc/calendar-templates/${calendarTemplateId}`);
}

export function previewCalendarTemplate(id: CalendarTemplateId, startDate: number) {
  return Endpoint.post<CalendarTemplatePreviewEventResponse[]>(`@gc/calendar-templates/preview/${id}`, { data: { startDate } });
}

export function importCalendarTemplate(request: CalendarImportRequest) {
  return Endpoint.post(`@gc/calendar-templates/import-template`, { data: request });
}

export function validateCalendarTemplate(scheduleId: CalendarTemplateId, orderId: string) {
  return Endpoint.post<VeryCompactCategoryResponse[]>(`@gc/calendar-templates/validate`, { data: { scheduleId, orderId } });
}

export function fetchTemplateImports(objectType: string, objectId: string) {
  return Endpoint.get<CalendarTemplateImportResponse[]>(`@gc/calendar-templates/imports`, { params: { objectType, objectId } });
}

export function shiftTemplateImport(id: CalendarTemplateImportId, request: ShiftTemplateImportRequest, dryRun = false) {
  return Endpoint.post<ShiftTemplateImportResponse>(`@gc/calendar-templates/shift-import/${id}`, { data: { ...request, dryRun } });
}

export function fetchManualEvents(objectType: string, objectId: string) {
  return Endpoint.get<ManualEventsSummaryResponse>(`@gc/calendar-templates/manual-events`, { params: { objectType, objectId } });
}

export function deleteManualEvents(objectType: string, objectId: string) {
  return Endpoint.post<{ success: boolean; deletedEvents: number }>(`@gc/calendar-templates/delete-manual-events`, { data: { objectType, objectId } });
}

export function deleteTemplateImport(id: CalendarTemplateImportId) {
  return Endpoint.delete<{ success: boolean; importKey: string; deletedEvents: number }>(`@gc/calendar-templates/import/${id}`);
}
